import React from 'react'
import './index.css'

const Footer = () => {
  return (
    <footer className="footer" id="footer">
      <p>&copy; 2025 Play Arena. All rights reserved.</p>
      <p>Contact us: info@playarena.com</p>
    </footer>
  )
}

export default Footer
